/**
 * @generated SignedSource<<8ba8987dee155ec3fc7a6fefcd47f664>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CalendarTeamEventEditComponentSelectCalendarPopover_storeCalendars$data = ReadonlyArray<{
  readonly color: string;
  readonly id: string;
  readonly isExternal: boolean;
  readonly title: string;
  readonly " $fragmentType": "CalendarTeamEventEditComponentSelectCalendarPopover_storeCalendars";
}>;
export type CalendarTeamEventEditComponentSelectCalendarPopover_storeCalendars$key = ReadonlyArray<{
  readonly " $data"?: CalendarTeamEventEditComponentSelectCalendarPopover_storeCalendars$data;
  readonly " $fragmentSpreads": FragmentRefs<"CalendarTeamEventEditComponentSelectCalendarPopover_storeCalendars">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "CalendarTeamEventEditComponentSelectCalendarPopover_storeCalendars",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "color",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isExternal",
      "storageKey": null
    }
  ],
  "type": "StoreCalendar",
  "abstractKey": null
};

(node as any).hash = "be78f1edfe49d1e0e2759dc8f05ac81b";

export default node;
